/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Selectorganization1Inputs */

const en_titles_selectorganization1 = /** @type {(inputs: Titles_Selectorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select organization`)
};

/**
* | output |
* | --- |
* | "Select organization" |
*
* @param {Titles_Selectorganization1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_selectorganization1 = /** @type {((inputs?: Titles_Selectorganization1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Selectorganization1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_selectorganization1(inputs)
});
export { titles_selectorganization1 as "titles_selectOrganization" }